import * as React from 'react'

type Dispatch = (action: Action) => void
type ProviderProps = { children: React.ReactNode }

export const actions = {
  classes: (itemId: string) => ({
    type: 'ADD_CLASS',
    payload: { itemId },
  }),
  articles: (itemId: string) => ({
    type: 'ADD_ARTICLE',
    payload: { itemId },
  }),
}
type Action = {
  type: 'ADD_CLASS' | 'ADD_ARTICLE' | 'REMOVE_CLASS' | 'REMOVE_ARTICLE'
  payload: { itemId: string }
}

type State = {
  classes?: Record<string, boolean>
  articles?: Record<string, boolean>
}

export interface ContextInterface {
  state: State
  dispatch: Dispatch
}

const Context = React.createContext<ContextInterface | undefined>(undefined)

const initialState: State = {
  classes: {},
  articles: {},
}

function reducer(state: State, action: Action): Partial<State> {
  switch (action.type) {
    case 'ADD_CLASS': {
      return {
        ...state,
        classes: { ...state.classes, [action.payload.itemId]: true },
      }
    }
    case 'ADD_ARTICLE': {
      return {
        ...state,
        articles: { ...state.articles, [action.payload.itemId]: true },
      }
    }
    case 'REMOVE_CLASS': {
      return {
        ...state,
        classes: { ...state.classes, [action.payload.itemId]: false },
      }
    }
    case 'REMOVE_ARTICLE': {
      return {
        ...state,
        articles: { ...state.articles, [action.payload.itemId]: false },
      }
    }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}

function Provider({ children }: ProviderProps): JSX.Element {
  const [state, dispatch] = React.useReducer(reducer, initialState)
  const value = { state, dispatch, actions }
  return <Context.Provider value={value}>{children}</Context.Provider>
}
const BookmarkedItemsProvider = Provider

function useBookmarkItems(): ContextInterface {
  const context = React.useContext(Context)
  if (context === undefined) {
    throw new Error('useBookmark must be used within a Provider')
  }
  return context
}
export { BookmarkedItemsProvider, useBookmarkItems }
